import { useAppSelector } from '../../app/hooks'
import { selectUser } from './loginSlice'
import { Navigate } from 'react-router-dom'

export default function PrivateRoute({ children }) {
    const user = useAppSelector(selectUser)
    return user?.id != null ? children : <Navigate to="/login" />
}
